module.exports = __webpack_public_path__ + "media/images/logo-30ba18abd790686c2512ca2eb727b8b5.png";